import styled from 'styled-components';
import { STRINGS } from 'config';
import { ColumnDiv } from 'styles/elements/div';
import { PrimaryButton, SecondaryButton, buttonPrimaryStyles } from 'styles/elements/buttons/primaryCare';
import { ClinicalReviewIcon } from 'assets/primaryCare/clinicalReview';
import emergency from 'assets/primaryCare/icons/emergency.png';
import media from 'styles/media';

const Endstate = styled(ColumnDiv)`
  flex: 1 1 auto;
  overflow-y: auto;
  overflow-x: hidden;
 -webkit-overflow-scrolling: touch;
  position: relative;
  ${props => props.theme.forceScrollBarStyles};
`;

const Inner = styled(ColumnDiv)`
  flex: 1 1 auto;
  position: absolute;
  width: 100%;
`;

const ReceivedHTML = styled(ColumnDiv)`
  padding: 0;
  
  .consult-alert__heading-wrapper {
    padding: 0 12% 10px;
    ${media.extraSmallAndBelow`
      padding-left: 15px;
      padding-right: 15px;
    `}
        
    .consult-alert__heading {
      margin: 0;
      color: white;
      padding: 65px 0 15px;
      line-height: 35px;
      font-size: 25px;
      font-family: sans-serif;
      font-weight: 300;
      padding-right: 150px;
      
      ${media.extraSmallAndBelow`
        padding-top: 50px;
        font-size: 20px;
        line-height: 30px;
        padding-right: 60px;
      `}
      
      .sr-only {
        position: absolute;
        left: -10000px;
        overflow: hidden;
        height: 1px;
        width: 1px;
      }
    }
  }
  
  .consult-alert--emergency .consult-alert__heading-wrapper {
    background: ${props => props.theme.emergencyColor};
    
    .consult-alert__heading {
      background: url(${STRINGS.S3_BUCKET}${emergency}) no-repeat right 40px center / 84px 80px;
      ${media.extraSmallAndBelow`
        background-size: 40px;
        background-position: right 50px;
      `}
    }
  }
  
  .consult-alert--urgent .consult-alert__heading-wrapper {
    background: ${props => props.theme.urgentColor};
  }
  
  .consult-alert--non-urgent .consult-alert__heading-wrapper {
    background: ${props => props.theme.nonUrgentColor};
  }
  
  .consult-alert__content {
    display: flex;
    flex-direction: column;
    padding: 10px 12% 20px;
    ${media.extraSmallAndBelow`
      padding: 10px 15px 5px;
    `}
  }
  
  .consult-alert__content--callout {
    background: ${props => props.theme.emergencyColor};
    color: white;
    margin-bottom: 0;
    margin-top: 2em;
    padding: 20px 15px;
    font-family: sans-serif;
    font-weight: 100;
    
    + p {
      background: ${props => props.theme.suicideColor};
      margin-top: 0;
      padding: 20px 15px;
      color: white;
      font-family: sans-serif;
      font-weight: 100;
    }
  }
  
  .consult-alert_button {
    ${buttonPrimaryStyles};
    display: flex;
    line-height: 1;
    justify-content: center;
    ${media.extraExtraSmall`
      line-height: 2;
    `};
    ${media.extraSmallAndBelow`
      line-height: 2;
    `};
  }
    
  a[target="_blank"].consult-alert_button::after {
    content: '';
  }
  a[target="_blank"].consult-alert_button :nth-child(2)::after {
    font-family: "fontello-nhs";
    content: "\\e80f";
    margin: 2px 4px 0;
    font-size: 11px;
    font-weight: normal;
  }
  
  ul {
    margin-top: 1.5em;
    padding-left: 20px;
    list-style-type: disc;
    
    li {
      list-style-type: disc;
    }
  }
`;

const ButtonsContainer = styled(ColumnDiv)`
  padding: 0 12% 5px;
  ${media.extraSmallAndBelow`
    padding-left: 15px;
    padding-right: 15px;
  `}
`;

const Confirm = styled(PrimaryButton)`
  margin-top: 0;
  margin-bottom: 1em;
  display: flex;
  justify-content: space-between;
`;

const Cancel = styled(SecondaryButton)`
  color: ${props => props.theme.anchorColor};
  border: none;
  text-align: left;
  padding-left: 0;
  display: flex;
`;

Endstate.Confirm = Confirm;
Endstate.Cancel = Cancel;
Endstate.ClinicalReviewIcon = ClinicalReviewIcon;
Endstate.Inner = Inner;
Endstate.ReceivedHTML = ReceivedHTML;
Endstate.ButtonsContainer = ButtonsContainer;

export default Endstate;
